import "styles/components/common/loader.css";
const Loader = ({
  isTransparent = false,
  transparentBackground = false,
}: {
  isTransparent?: boolean;
  transparentBackground?: boolean;
}) => {
  return (
    <div
      className={`${
        isTransparent ? "loaderContainerTransparent" : "loaderContainer"
      }`}
      style={
        transparentBackground ? { backgroundColor: "transparent" } : undefined
      }
    >
      <span className="loader"></span>
    </div>
  );
};

export default Loader;
